import React, { Component } from "react";
import { Link } from "preact-router/match";
import styles from "./MobileMenu.scss";
import SignUpButton from "./global/SignUpButton";
import CMSComponent from "./CMSComponent";

import { css } from "emotion";

import config from "../config";
import ColorServices from "../services/ColorServices";
import { firstOfType } from "../utils/CssUtils";

const menuIcon = require("../assets/hamburger/ic_menu.svg");
const closeIcon = require("../assets/hamburger/ic_close.svg");
const HumanitixLogo = require("../assets/humanitixLogos/mobile.svg");

const openButton = css({
  border: "none",
  backgroundColor: "transparent"
});

const closeButton = css({
  border: "none",
  backgroundColor: "transparent"
});

const header = css({
  display: "flex",
  justifyContent: "space-between",
  padding: "22px 14px",
  borderBottom: "1px solid #dedede",
  marginBottom: 24
});

const linksList = css({
  listStyle: "none",
  paddingLeft: 14,
  li: {
    fontSize: 16,
    marginBottom: 16
  }
});
const menuWrapper = css({
  position: "absolute",
  width: "100vw",
  minHeight: 300,
  background: "white",
  transition: "0.25s ease-out",
  boxShadow: "0 2px 3px 0 rgba(32, 7, 64, 0.13)",
  borderBottomLeftRadius: 4,
  borderBottomRightRadius: 4,
  left: 0,
  top: 0,
  zIndex: 1000
});

const footer = css({
  backgroundColor: ColorServices.getColor("greyBackground"),
  padding: "16px 25%"
});

class MobileMenu extends Component {
  openMenu(evt) {
    evt.stopPropagation();
    this.setState({
      open: true
    });
  }

  closeMenu(evt) {
    evt.stopPropagation();
    this.setState({
      closing: true
    });
    this.hideMenu();
  }

  hideMenu() {
    setTimeout(() => {
      this.setState({
        open: false,
        closing: false
      });
    }, 200);
  }
  constructor() {
    super();
    this.state = {
      open: false,
      closing: false
    };
    this.openMenu = this.openMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.hideMenu = this.hideMenu.bind(this);
  }
  render() {
    let { open } = this.state;
    const { locale, localeData } = this.props;
    const { consoleURL } = localeData;

    return (
      <div style={{ overflow: "hidden" }}>
        <div
          className={menuWrapper}
          style={{ transform: `translateX(${open ? "0vw" : "100vw"})` }}
        >
          <div className={header}>
            <img src={HumanitixLogo} alt="Humanitix logo" />
            <button
              onClick={this.closeMenu}
              className={closeButton}
              aria-expanded
              aria-label="Close menu"
            >
              <img src={closeIcon} alt="Close Icon" />
            </button>
          </div>
          <ul className={linksList}>
            <li>
              <Link
                activeClassName="link"
                href={`/${locale}/`}
                aria-label="Home - Humanitix"
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                activeClassName="link"
                href={`/${locale}/search`}
                aria-label="Search events"
              >
                Search Events
              </Link>
            </li>
            <li>
              <Link
                activeClassName="link"
                href={`/${locale}/features-and-pricing`}
                aria-label="Features and pricing"
              >
                Features &amp; Pricing
              </Link>
            </li>
            <li>
              <Link
                activeClassName="link"
                href={`/${locale}/our-impact`}
                aria-label="Our Impact"
              >
                Our Impact
              </Link>
            </li>
            <li>
              <Link
                activeClassName="link"
                href={`/${locale}/about-us`}
                aria-label="About us"
              >
                About Us
              </Link>
            </li>
            <li>
              <Link
                activeClassName="link"
                href={`/${locale}/contact-us`}
                aria-label="Contact us"
              >
                Contact Us
              </Link>
            </li>
          </ul>
          <div className={footer}>
            <SignUpButton size="wide" ariaLabel="Sign In">
              Sign In
            </SignUpButton>
          </div>
        </div>
        <div style={{ position: "relative", zIndex: 10 }}>
          <button
            onClick={this.openMenu}
            className={openButton}
            aria-expanded={open}
            aria-label="Open menu"
          >
            <img src={menuIcon} alt="Menu Icon" />
          </button>
        </div>
      </div>
    );
  }
}

export default CMSComponent(null, MobileMenu);
